module.exports = __webpack_public_path__ + "img/SouthEthiopia_Certificate.1f7bd48f.jpg";